import { FlexBox } from "components/Common/FlexBox"
import styled from "styled-components"

const NoSchedulesText = styled.p`
  text-align: center;
  color: #1c1f21;
  font-size: 16px;
  line-height: 120%;
`

const NoSchedules = () => {
  return (
    <FlexBox
      $direction="column"
      $alignItems="center"
      $justify="center"
      style={{ paddingTop: 48 }}
      $gap={24}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="97"
        height="95"
        viewBox="0 0 97 95"
        fill="none"
      >
        <path
          d="M84.4336 10H78.759V17.1084C78.759 19.9534 76.472 22.2679 73.6609 22.2679C70.8498 22.2679 68.5629 19.9534 68.5629 17.1084V10H28.436V17.1084C28.436 19.9534 26.149 22.2679 23.3379 22.2679C20.5268 22.2679 18.2399 19.9534 18.2399 17.1084V10H12.5664C9.49205 10 7 12.5221 7 15.6334V85C7 89.9706 11.0294 94 16 94H81C85.9706 94 90 89.9706 90 85V15.6334C90 12.5221 87.5079 10 84.4336 10ZM85.4683 84.4137C85.4683 87.1751 83.2297 89.4137 80.4683 89.4137H16.5317C13.7703 89.4137 11.5317 87.1751 11.5317 84.4137V38.9234C11.5317 36.162 13.7703 33.9234 16.5317 33.9234H80.4683C83.2297 33.9234 85.4683 36.162 85.4683 38.9234V84.4137Z"
          fill="#00263A"
          fillOpacity="0.14"
        />
        <path
          d="M23 21C24.6566 21 26 19.5017 26 17.654V3.34603C26 1.49834 24.6566 0 23 0C21.3434 0 20 1.49834 20 3.34603V17.654C20 19.5017 21.3434 21 23 21Z"
          fill="#00263A"
          fillOpacity="0.14"
        />
        <path
          d="M77 3.34603C77 1.49807 75.6569 0 74 0C72.3431 0 71 1.49807 71 3.34603V17.654C71 19.5019 72.3431 21 74 21C75.6569 21 77 19.5019 77 17.654V3.34603Z"
          fill="#00263A"
          fillOpacity="0.14"
        />
        <path
          d="M48.5 83C60.3736 83 70 73.5975 70 62C70 50.4025 60.3736 41 48.5 41C36.6264 41 27 50.4025 27 62C27 73.5975 36.6264 83 48.5 83ZM35.9833 49.7755C39.3266 46.5099 43.7719 44.7115 48.5 44.7115C53.2281 44.7115 57.6734 46.5099 61.0167 49.7755C64.3601 53.0411 66.2013 57.383 66.2013 62.0012C66.2013 66.6193 64.3601 70.9612 61.0167 74.2268C57.6734 77.4924 53.2281 79.2908 48.5 79.2908C43.7719 79.2908 39.3266 77.4924 35.9833 74.2268C32.6399 70.9612 30.7987 66.6193 30.7987 62.0012C30.7987 57.383 32.6399 53.0411 35.9833 49.7755Z"
          fill="#00263A"
          fillOpacity="0.14"
        />
        <path
          d="M48.499 64.0044L53.882 64.9723C53.987 64.9908 54.0908 65 54.1936 65C55.056 65 55.82 64.359 55.973 63.45C56.1439 62.4325 55.4849 61.4646 54.5019 61.2879L50.6169 60.5891V50.8699C50.6169 49.8374 49.8071 49 48.8085 49C47.8098 49 47 49.8374 47 50.8699V62.161C47 63.07 47.6322 63.8473 48.4979 64.0032L48.499 64.0044Z"
          fill="#00263A"
          fillOpacity="0.14"
        />
      </svg>

      <NoSchedulesText>
        You have no meals scheduled yet. Plan ahead by logging food for a future
        date—meals will be added automatically!
      </NoSchedulesText>
    </FlexBox>
  )
}

export default NoSchedules
